export default function () {
    new Swiper(".flagship-programs-module-swiper", {
        spaceBetween: 24,
        autoHeight: true,
        loop:true,
        slidesPerView: 1,
        navigation: {
            nextEl: ".flagship-programs-module-swiper-navigation-button.next",
            prevEl: ".flagship-programs-module-swiper-navigation-button.prev",
        },
    });
}
